import React, { useContext, useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import { toast } from "react-toastify";
import { ContextData } from "../../../../../context/Context";
import { Multipartrequest, Postrequest, Putrequest } from "../../../../../context/AxiosRequest";
import SoundAlert from "../../../../../routes/SoundAlert";
import baseUrl from "../../../../../BaseURL";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function BioData({ formData,verify_status, NigerianStates }) {


   const Navigate = useNavigate()
  const [error, setError] = useState("");
  const { UserTokens, accesstoken ,setReloadBioForms,ReloadBioForms} = useContext(ContextData);
  const [PicFile, setPicFile] = useState(null)
  const [Btn,setBtn] = useState(true)
  let checkStatus = ["verified","approved","returned_by_approver","accepted","rejected"]
   const [formDatas, setFormDatas] = useState({
       
          fname:  "",
          md_name:  "",
          lname:  "",
          d_o_b: "",
         // email: "",
          mobileNumber:  "",
         
      });


      
  
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormDatas((prevData) => ({   ...prevData, [name]: value,}));
    };

  const handleImageChange = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const validTypes = ["image/jpeg", "image/png", "image/jpg"];
  if (!validTypes.includes(file.type)) {
    setError("Only JPG, JPEG and PNG images are allowed.");
    toast.warn("Only JPG, JPEG and PNG images are allowed.");
    SoundAlert("error");
    return;
  }

  // Reject files larger than 2MB
  const MAX_ACCEPT_SIZE = 2 * 1024 * 1024; // 2MB
  const TARGET_MAX = 500 * 1024; // 500KB

  if (file.size > MAX_ACCEPT_SIZE) {
    setError("File is too large. Maximum allowed size is 2 MB.");
    toast.warn("File is too large. Maximum allowed size is 2 MB.");
    SoundAlert("error");
    return;
  }

  // If file already <= 500KB, accept it
  if (file.size <= TARGET_MAX) {
    setError("");
    setPicFile(file);
     setBtn(false)
    return;
  }

  // Otherwise try to compress (best-effort) to be around <= 500KB
  const compressImage = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onerror = (err) => reject(err);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result;

        img.onload = async () => {
          try {
            // start with original dimensions
            let width = img.width;
            let height = img.height;

            // We'll try multiple passes: reduce quality first, then reduce size if needed
            const attemptCompress = async (quality, scale) =>
              new Promise((res) => {
                const canvas = document.createElement("canvas");
                canvas.width = Math.round(width * scale);
                canvas.height = Math.round(height * scale);
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                canvas.toBlob(
                  (blob) => {
                    if (!blob) return res(null);
                    const newFile = new File([blob], file.name, { type: file.type });
                    res(newFile);
                  },
                  file.type,
                  quality
                );
              });

            // Try quality reductions at original dimensions first
            const qualitySteps = [0.9, 0.8, 0.7, 0.6, 0.5, 0.45, 0.4];
            for (let q of qualitySteps) {
              const candidate = await attemptCompress(q, 1.0);
              if (candidate && candidate.size <= TARGET_MAX) return resolve(candidate);
            }

            // If still too big, progressively scale down and try a few qualities
            const scaleSteps = [0.9, 0.8, 0.7, 0.6, 0.5]; // scale factors
            for (let s of scaleSteps) {
              for (let q of [0.8, 0.7, 0.6, 0.5, 0.45]) {
                const candidate = await attemptCompress(q, s);
                if (candidate && candidate.size <= TARGET_MAX) return resolve(candidate);
              }
            }

            // Couldn't reach target — return the smallest candidate we could produce (last attempt)
            // Produce a final best-effort compressed file
            const finalCandidate = await attemptCompress(0.45, 0.5);
            if (finalCandidate) return resolve(finalCandidate);

            // fallback to original if something unexpected happens
            return resolve(file);
          } catch (err) {
            return reject(err);
          }
        };

        img.onerror = (err) => reject(err);
      };
    });

  try {
    toast.info("Compressing image, please wait...");
    const compressed = await compressImage(file);
    if (!compressed) {
      setError("Image compression failed.");
      toast.error("Image compression failed.");
      SoundAlert("error");
      return;
    }

    // If compressed is still > TARGET_MAX, warn but accept compressed result
    if (compressed.size > TARGET_MAX) {
      const sizeKb = Math.round(compressed.size / 1024);
      setError("");
      setPicFile(compressed);
      setError(`Could not reach 500KB. Compressed image is ~${sizeKb}KB and will be uploaded. click save.`);
      SoundAlert("warning");
      setBtn(false)
    } else {
      setError("");
      setPicFile(compressed);
      toast.success("Image compressed successfully and ready for upload.");
      SoundAlert("success");
      setBtn(false)
    }
  } catch (err) {
    console.error("Compression error:", err);
    setError("An error occurred while compressing the image.");
    toast.error("An error occurred while compressing the image.");
    SoundAlert("error");
     setBtn(true)
    // as fallback, do not set the file
  }
};


  const HandleSubmit = async () => {


    if (!PicFile) {
      toast.error("Please select a Photo Passport before uploading.");
      SoundAlert("error");
      return;
    }

    const formDatapic = new FormData();
    formDatapic.append("file", PicFile);
    formDatapic.append("usertoken", UserTokens);

    try {

                 axios.put(`${baseUrl}/auth/upload_picture`,formDatapic,{
                withCredentials: true,
                headers: {
                  'Accept' : 'application/json',
                  ContentType: "multipart/form-data",
                }}).then(res=>{

                      if (res?.status) {
                      toast.success(res.textStatus || "Photo uploaded successfully!");
                      SoundAlert("success");
                      setReloadBioForms(!ReloadBioForms)
                      } else {
                      toast.warn(res?.textStatus || "Error occurred while uploading file");
                      SoundAlert("error");
                      }
      
          
                }).catch(err=> {
                    if(err){ 
                      toast.error(err.message)
                      console.log(err)
                      return
          
                    }   
                })


     
   
    } catch (err) {
      console.error(err);
      toast.error("Network error during upload");
      SoundAlert("error");
    }
  };



      // Handle data to server if succeed
      const handleUpdate = (type) => {

  
        if(type === "f"){
  
          if (!formDatas.fname || formDatas.fname.trim() === "") {
                  SoundAlert("error") 
              toast.error('Please fill in all required fields.');
                return
            }
   

        }
  

        if(type === "m"){
  
          if (!formDatas.md_name || formDatas.md_name.trim() === "") {
                  SoundAlert("error") 
              toast.error('Please fill in all required fields.');
                return
            }
  
  
        }
  
  
  
        if(type === "l"){
  
          if (!formDatas.lname || formDatas.lname.trim() === "") {
                   SoundAlert("error")  
            toast.error('Please fill in all required fields.');
              return
          }
  

        }
  
       
        if(type === "d_o_b"){
  
  
          if (!formDatas.d_o_b || formDatas.d_o_b.trim() === "") {
                   SoundAlert("error") 
            toast.error('Please fill in all required fields.');
              return
          }
  

        }




        if(type === "mb_n"){
  
          if (!formDatas.mobileNumber || formDatas.mobileNumber.trim() === "") {
            SoundAlert("error") 
            toast.error('Please fill in all required fields.');
              return
          }

  
        }
   



     
  
      
  
      axios.put(`${baseUrl}/auth/bio_update`,{...formDatas, user_token: UserTokens},{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json'
        }}).then(res=>{
  
          
         if(res.data.status){
          SoundAlert("success")
          toast.success(res.data.textStatus);
          setReloadBioForms(!ReloadBioForms)
            }
        
  
        }).catch(err=> {
            if(err){
                
              toast.error(err.message)
              console.log(err)
              return
  
            }   
        })
  
  
   
  }
  
 
   useEffect(()=>{

           setFormDatas(prev =>({
             ...prev,
          fname: formData.bioData.fname,
          md_name: formData.bioData.md_name,
          lname: formData.bioData.lname,
          d_o_b: formData.bioData.d_o_b,
          mobileNumber: formData.bioData.mobileNumber,


           }))
   },[formData])
  
 if(checkStatus.includes(verify_status)){
      
         Navigate("/application/home")
        toast.warn("Your application cannot be modified after verification")
        toast.success("Application locked. Visit my application page to review the submission status")
         SoundAlert("error")
         return
  }

  return (
    <div>
     
      <TextField
        label="First Name"
        name="fname"
        value={formDatas.fname}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
         InputProps={{ 
                  endAdornment: (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={()=> handleUpdate("f")}
                       
                    >
                      Save
                    </Button>
        
            )}}
      /> 
      <TextField
        label="Middle Name"
        name="md_name"
        value={formDatas.md_name}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
         InputProps={{ 
                  endAdornment: (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={()=> handleUpdate("m")}
                       
                    >
                      Save
                    </Button>
        
            )}}
      />
      <TextField
        label="Last Name"
        name="lname"
        value={formDatas.lname}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
         InputProps={{ 
                  endAdornment: (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={()=> handleUpdate("l")}
                       
                    >
                      Save
                   </Button>
        
           )}}
      />
      <TextField
        label="Date Of Birth"
        name="d_o_b"
        value={formDatas.d_o_b}
        onChange={handleChange}
        fullWidth
        margin="dense"
        type="date"
        required
         InputProps={{ 
                  endAdornment: (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={()=> handleUpdate("d_o_b")}
                       
                    >
                      Save
                    </Button>
        
            )}}
      />
      <TextField
        label="Mobile Number"
        name="mobileNumber"
        value={formDatas.mobileNumber}
        onChange={handleChange}
        fullWidth
        margin="dense"
        required
       inputProps={{ maxLength:  11, inputMode: "numeric",minLength: 11, pattern: "[0-9]{11}"}}
         InputProps={{ 
                  endAdornment: (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={()=> handleUpdate("mb_n")}
                       
                    >
                      Save
                    </Button>
        
            ),
            
          
          }}
      />

      <p className="pt-1 pb-1 font-extrabold">Photo Passport <span className="bg-green-900 text-white p-1"> {formData.bioData.picture && "uploaded successfully"}</span></p>
      <TextField
        name="picture"
        onChange={handleImageChange}
        fullWidth
        margin="dense"
        type="file"
        required
        InputProps={{
          endAdornment: (
            <Button
              variant="contained"
              color="secondary"
              onClick={HandleSubmit}
              disabled={Btn}
            >
              Save
            </Button>
          ),
        }}
      />
     
      {error && <p style={{ color: "red", fontSize: "0.8rem" }}>{error}</p>}
    </div>
  );
}

export default BioData;
